export { TopIconCardModule } from './top-icon-card.module';
export { TopIconCardComponent } from './top-icon-card.component';
export {
  TopIconCardIconDirective,
  TopIconCardHeaderDirective,
  TopIconCardBodyDirective,
  TopIconCardFooterDirective,
} from './top-icon-card-sections';
